// extracted by mini-css-extract-plugin
module.exports = {"row":"_7f8ea54d","isMobile":"_ce6946bd","item":"_8e572652","link":"_53f2fc07","twitter":"_f38040da","facebook":"_2da41fcf","pinterest":"_3ef4a0f1","instagram":"_9e30bebf"};